import { render, staticRenderFns } from "./TableWlPatients.vue?vue&type=template&id=8d6c33fc&scoped=true"
import script from "./TableWlPatients.vue?vue&type=script&lang=js"
export * from "./TableWlPatients.vue?vue&type=script&lang=js"
import style0 from "./TableWlPatients.vue?vue&type=style&index=0&id=8d6c33fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6c33fc",
  null
  
)

export default component.exports